import styles from './output_block.module.css';

export const OutputBlock = ({label, status, children}: Props) => {
  return (
    <div className={styles[status]}>
      <div className={styles.label}>{label}</div>
      <div className={styles.output}>
        {typeof children === 'string' ? (
          <div className={styles.verbatim}>{children}</div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

type Props = {
  label: string;
  status: 'info' | 'error' | 'passed' | 'failed';
  children?: React.ReactNode;
};
